exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#addRole[data-v-62c2f3ee]:hover {\n  cursor: pointer;\n}\n.exercise-header[data-v-62c2f3ee] {\n  margin-bottom: 1em;\n}\n.over-border[data-v-62c2f3ee] {\n  position: absolute;\n  right: 4em;\n}\ninput[type=\"text\"][data-v-62c2f3ee]\n{\n  background: transparent;\n  border: none;\n}\ninput[type=\"text\"][data-v-62c2f3ee]:hover {\n  border: 1px solid #999;\n  color: #000;\n}\n.table-responsive[data-v-62c2f3ee] {\n  overflow-y: visible !important;\n  overflow-x: hidden;\n}\n.btn-block[data-v-62c2f3ee] {\n  background-color: white;\n}\n.text[data-v-62c2f3ee] {\n  font-size: 1.3em;\n}\n.grayout[data-v-62c2f3ee] {\n  opacity: 0.6;\n  filter: alpha(opacity = 60);\n  cursor: not-allowed;\n  pointer-events:none;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-62c2f3ee","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/admin/group/Classes.vue
// module id = 918
// module chunks = 1